export const ModalitaRitiroConsegna = Object.freeze({
  RITIRO: "RITIRO",
  CONSEGNA: "CONSEGNA",
});

export const criteriInvioShape = {
  modalita: ModalitaRitiroConsegna.RITIRO,
  raggioKm: 10,
  selectedSellerIds: [],
};

export const createCriteriInvioModel = (overrides = {}) => ({
  ...criteriInvioShape,
  ...overrides,
  selectedSellerIds: Array.isArray(overrides.selectedSellerIds)
    ? [...overrides.selectedSellerIds]
    : [...criteriInvioShape.selectedSellerIds],
});


